<template lang="html">
  <div class="charge-new">
    <a
      v-if="allowCreateCharge"
      href="#"
      class="btn btn-primary"
      ref="openChargeButton"
      @click.prevent="openChargeModal">Adicionar recarga</a>
    <router-link
      v-else
      class="btn btn-primary"
      :to="{ name: 'financialData', params: { financialProps: financialData, returnTo: $route.name }}">
      Para realizar recargas informe seus dados aqui
    </router-link>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="chargeRequest"
      ref="chargeRequest"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Adicionar recarga</h5>
            <button
              type="button"
              class="close"
              @click.prevent="closeChargeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div
              v-if="chargeError"
              class="alert alert-danger"
              role="alert">
              <span v-html="chargeError.message" />
            </div>
            <form
              ref="chargeForm"
              class="charge-form">
              <div class="form-group">
                <h3>Informe o <b>valor da recarga</b> que deseja</h3>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 chargeAmount">
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <label class="input-group-text">R$</label>
                    </span>
                    <input
                      class="form-control"
                      ref="chargeAmount"
                      type="number"
                      min="20"
                      max="50000"
                      step="1"
                      v-model.number="chargeAmount"
                      @keydown.enter="generateCharge"
                      required>
                    <span class="input-group-append">
                      <label class="input-group-text">,00</label>
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="hasDynamicTariff">
                <div class="form-group">
                  <h3>Ou selecione o <b>desconto</b> deseja receber</h3>
                </div>
                <div class="form-group row">
                  <div :class="`col ${sliderName}`">
                    <div
                      class="range-slider"
                      @click.prevent="sliderClick">
                      <input
                        class="form-control"
                        :id="sliderName"
                        type="input"
                        data-slider-tooltip="hide"
                        :data-slider-ticks-snap-bounds="sliderTicksSnapBounds"
                        :data-slider-ticks-labels="sliderTicksLabels"
                        :data-ticks_positions="sliderTicksPositions">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-6"><h5>Minuto Móvel</h5></div>
                    <div class="col-lg-6"><h5>Minuto Fixo</h5></div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6"><h2>R$ {{ mobilePrice }}</h2></div>
                    <div class="col-sm-6"><h2>R$ {{ fixedlinePrice }}</h2></div>
                  </div>
                </div>
                <div>
                  <h5 v-if="chargeAmount >= 500">
                    Com esse desconto a cada <b>1000 minutos</b> você economizará em média <b>R$ {{ averageSaving }},00</b>
                  </h5>
                </div>
              </div>
            </form>
            <hr>
            <div>
              <span>Após a compensação, seus créditos serão adicionados automaticamente.</span><br>
              <span>Para pagamentos com cartão de crédito ou débito, a compensação é quase sempre instantânea.</span><br>
              <span>Quando você utiliza o PIX, a compensação pode ocorrer em até 24 horas, embora é quase sempre instantânea.</span><br>
              <span>Se você optar por pagar com boleto bancário, a compensação ocorrerá no próximo dia útil, podendo levar até 3 dias.</span>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click.prevent="closeChargeModal">Cancelar</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="generateCharge">Gerar pagamento</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="chargeAsaasSuccess"
      ref="chargeAsaasSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Recarga gerada com sucesso!</h5>
            <button
              type="button"
              class="close"
              @click.prevent="closeChargeSuccessAsaasModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5>
              Para realizar o pagamento
              <a
                class="link"
                :href="this.paymentLink"
                target="_blank">
                clique aqui
              </a>
            </h5>
            <span>Após a compensação, seus créditos serão adicionados automaticamente.</span><br>
            <span>Para pagamentos com cartão de crédito ou débito, a compensação é quase sempre instantânea.</span><br>
            <span>Quando você utiliza o PIX, a compensação pode ocorrer em até 24 horas, embora é quase sempre instantânea.</span><br>
            <span>Se você optar por pagar com boleto bancário, a compensação ocorrerá no próximo dia útil, podendo levar até 3 dias.</span>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="closeChargeSuccessAsaasModal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="chargeErrorModal"
      ref="chargeErrorModal"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h1>Infelizmente tivemos um problema ao gerar sua recarga :~(</h1>
            <p class="support-message-error">
              Porfavor, entre em contato com nosso suporte
              <a
                href="https://wa.me/+554833328503"
                class="link"
                target="_blank">(48) 3332-8503 (WhatsApp)</a>
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              aria-label="OK">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'

const MOBILE_PRICES = ['0,35', '0,33', '0,30', '0,25', '0,19', '0,12']
const MOBILE_AVERAGE_SAVINGS = [0, 18, 53, 105, 158, 228]
const FIXEDLINE_PRICES = ['0,08', '0,079', '0,078', '0,076', '0,074', '0,07']
const FIXEDLINE_AVERAGE_SAVINGS = [0, 1, 2, 4, 6, 10]
const CHARGE_AMOUNTS = [200, 500, 1000, 2000, 3000, 5000]
const CHARGE_AMOUNT_TIERS = [0, 5, 15, 30, 45, 65]
const CHARGE_AMOUNT_POSITIONS = [0, 20, 40, 60, 80, 100]

export default {
  name: 'ChargeNew',
  props: {
    sliderName: {
      type: String,
      default: 'chargeAmountSlider'
    }
  },
  data () {
    return {
      chargeAmount: 200,
      chargeError: null,
      paymentLink: null,
      sliderTicks: CHARGE_AMOUNT_POSITIONS,
      sliderTicksPositions: CHARGE_AMOUNT_POSITIONS,
      sliderTicksLabels: CHARGE_AMOUNT_TIERS.map(v => `${v}%`),
      sliderTicksSnapBounds: 20,
      hasDynamicTariff: false,
      financialData: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getFinancialData()
      this.getSoftswitchIntegration()
        .then(() => {
          this.buildSlider()
        })
    })
  },
  methods: {
    getSoftswitchIntegration () {
      return new Promise((resolve) => {
        const softswitchIntegration = this.$store.state.auth.softswitchIntegration
        if (softswitchIntegration && softswitchIntegration.metadata) {
          if (softswitchIntegration.metadata.hasDynamicTariff) this.hasDynamicTariff = softswitchIntegration.metadata.hasDynamicTariff
          return resolve()
        }
      })
    },
    resetCharge () {
      this.chargeAmount = 200
      this.chargeError = null
    },
    generateCharge (event) {
      event.target.disabled = true
      setTimeout(() => { event.target.disabled = false }, 5000)
      this.chargeError = null
      const form = this.$refs.chargeForm
      if (form && !form.checkValidity()) {
        this.chargeError = {
          message: 'Recarga mínima é de R$ 20,00 e máxima de R$ 5.000,00'
        }
        return this.generateChargeShown()
      }
      this.generateChargeAsaas()
    },
    generateChargeShown () {
      this.$refs.chargeAmount.focus()
    },
    openChargeModal () {
      $(this.$refs.chargeRequest).appendTo('body').modal('show')
    },
    closeChargeModal () {
      this.resetCharge()
      $(this.$refs.chargeRequest).modal('hide')
      this.$refs.openChargeButton.focus()
    },
    generateChargeAsaas () {
      const dueDate = new Date()
      dueDate.setDate(dueDate.getDate() + 3)
      loopback.post('/charges', {
        amount: this.chargeAmount,
        paymentMethod: 'UNDEFINED',
        dueDate: dueDate.toISOString().slice(0, 10)
      }).then(charge => {
        EventBus.$emit('reload-charge-history', charge.amount)
        $(this.$refs.chargeRequest).modal('hide')
        if (charge && charge.paymentLink) {
          this.paymentLink = charge.paymentLink
          $(this.$refs.chargeAsaasSuccess).appendTo('body').modal('show')
        } else {
          $(this.$refs.chargeErrorModal).appendTo('body').modal('show')
        }
        window.open(this.paymentLink, '_blank')
      }).catch(err => {
        if (err.statusCode === 400 && err.message === 'there is already a pending charge') {
          this.chargeError = {
            message: 'Já existe uma recarga pendente, favor aguardar ou realizar o pagamento para gerar uma nova recarga'
          }
          this.generateChargeShown()
        } else if (err.details && err.details.messages && err.details.messages.dueDate) {
          this.chargeError = {
            message: err.details.messages.dueDate[0]
          }
          this.generateChargeShown()
        } else {
          this.chargeError = {
            message: [
              'Infelizmente tivemos um problema ao gerar sua recarga,',
              '<a href="https://wa.me/+554833328503" target="_blank" class="link">clique aqui e fale com nosso suporte via WhatsApp!</a>'
            ].join(' ')
          }
        }
      })
    },
    closeChargeSuccessAsaasModal () {
      this.resetCharge()
      $(this.$refs.chargeAsaasSuccess).modal('hide')
      this.$refs.openChargeButton.focus()
    },
    getAmountByPosition (position) {
      return CHARGE_AMOUNTS[CHARGE_AMOUNT_POSITIONS.findIndex(v => parseInt(v) === parseInt(position))]
    },
    getPositionByAmount (amount) {
      const positionIndex = CHARGE_AMOUNTS.reduce((findIndex, tier, index) => {
        if (parseInt(amount) >= parseInt(tier)) {
          findIndex = index
        }
        return findIndex
      }, 0)
      return positionIndex
    },
    getAmountPositionByAmount (amount) {
      return CHARGE_AMOUNT_POSITIONS[this.getPositionByAmount(amount)]
    },
    buildSlider () {
      $(`#${this.sliderName}`).slider({
        value: this.getAmountPositionByAmount(this.chargeAmount),
        ticks: this.sliderTicks,
        ticks_positions: this.sliderTicksPositions,
        ticks_labels: this.sliderTicksLabels,
        ticks_snap_bounds: this.sliderTicksSnapBounds
      }).on('slide', (slideEvt) => {
        this.chargeAmount = this.getAmountByPosition(slideEvt.value)
      })
    },
    sliderClick () {
      this.chargeAmount = this.getAmountByPosition($(`#${this.sliderName}`)[0].value)
    },
    getFinancialData () {
      const financialData = this.$store.state.auth.financialData
      if (financialData) this.financialData = financialData
    }
  },
  computed: {
    mobilePrice () {
      return MOBILE_PRICES[this.getPositionByAmount(this.chargeAmount)]
    },
    fixedlinePrice  () {
      return FIXEDLINE_PRICES[this.getPositionByAmount(this.chargeAmount)]
    },
    averageSaving () {
      return MOBILE_AVERAGE_SAVINGS[this.getPositionByAmount(this.chargeAmount)] + FIXEDLINE_AVERAGE_SAVINGS[this.getPositionByAmount(this.chargeAmount)]
    },
    allowCreateCharge () {
      return this.financialData && this.financialData.status === 'ACTIVE'
    }
  },
  watch: {
    chargeAmount (amount) {
      $(`#${this.sliderName}`).slider('setValue', this.getAmountPositionByAmount(amount))
    },
    '$store.state.auth.financialData': function () {
      this.getFinancialData()
    }
  }
}
</script>

<style lang="scss">
.support-message-error {
  font-size: large;
}
.buttons {
  margin: auto;
  text-align: center;
}
.chargeAmount {
  text-align: center;
}
.chargeAmount .input-group {
  max-width: 250px;
  margin: auto;
}
.chargeAmount .input-group {
  input {
    text-align: right;
    height: 40px;
    font-size: x-large;
  }
  .input-group-prepend label {
    height: 40px;
    font-size: x-large;
  }
  .input-group-append label {
    height: 40px;
    font-size: x-large;
  }
}
.slider.slider-horizontal {
  width: 90% !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Charge/New.vue